import apiClient from '../utilities/apiClient.utility';

const transactionsUrl = `${window.config.CONNECT_URLS.transactions}`;

export const postTransactionBatchPurchaseApprove = async ({
  transaction_batch_id,
  connect_program_id,
  user_id,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-batch/${transaction_batch_id}/approve`,
    { user_id: user_id }
  );
  return result;
};

export const putTransactionCodeFreeGoodApprove = async ({
  transaction_code_id,
  connect_program_id,
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${transaction_code_id}/approve`,
    null
  );
  return result;
};

export const postTransactionBatchPurchaseDisapprove = async ({
  transaction_batch_id,
  connect_program_id,
  user_id,
  reason = null
}) => {
  return await apiClient.post(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-batch/${transaction_batch_id}/disapprove`,
    { user_id: user_id, reason : reason }
  );
};

export const freeGoodTransactionManualUpdate = async ({
  connect_program_id,
  transaction_batch_id,
  action,
  payload,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-batch/${transaction_batch_id}/free-good/${action}`,
    payload
  );
  return result;
};

export const freeGoodTransactionConfirmation = async ({
  connect_program_id,
  transaction_code_id,
  action,
  payload,
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${transaction_code_id}/${action}`,
    payload
  );
  return result;
};

export const extendPatientTransactionCode = async ({
  program_id,
  transaction_code_id,
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${program_id}/dashboard/transaction-code/${transaction_code_id}/extend`,
    {}
  );
  return result;
};

export const voidTransactionBatch = async ({
  program_id,
  transaction_batch_id,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${program_id}/dashboard/transaction-batch/${transaction_batch_id}/void`,
    {}
  );
  return result;
};

export const voidTransactionBatchId = async ({
  program_id,
  transaction_batch_id,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${program_id}/voidtransaction`,
    { transaction_id: transaction_batch_id }
  );
  return result;
};

export const voidTransactionBatchStellar = async ({
  program_id,
  transaction_batch_id,
}) => {
  const result = await apiClient.delStellar(`${transactionsUrl}`, {
    transaction_batch_id,
    isCustomerSupport: true,
  });
  return result;
};

export const updateTransactionLineItem = async ({
  connect_program_id,
  transaction_line_item_id,
  payload,
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-line-item/${transaction_line_item_id}/update`,
    payload
  );
  return result;
};

export const updateTransactionCodeDetails = async ({
  transaction_code_id,
  connect_program_id,
  payload
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${transaction_code_id}/update`,
    payload
  );
  return result;
};


export const voidTransactionLineItem = async ({
  connect_program_id,
  transaction_line_item_id,
  payload
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-line-item/${transaction_line_item_id}/void`,
    payload
  );
  return result;
};

export const getTransactionConfig = async ({ program_id }) => {
  return await apiClient.get(
    `${transactionsUrl}/${program_id}/private/config`
  );
}

export const validateTransaction = async ({
  transaction_batch_id,
  connect_program_id,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-batch/${transaction_batch_id}/validate`,
  );
  return result;
};

export const updateFreeBoxStatusAndDetails = async ({
  transaction_code_id,
  connect_program_id,
  payload
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/free-box/${transaction_code_id}/update`,
    payload
  );
  return result;
};

export const cancelFreeBoxEligibility = async ({
  transaction_code_id,
  connect_program_id,
  payload
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/free-box/${transaction_code_id}/cancel-eligibility`,
    payload
  );
  return result;
};

export const updateVoucherRedeemDate = async ({
  connect_program_id,
  voucher_code,
  payload
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${voucher_code}/updateredeemdate`,
    payload
  );
  return result;
};

export const updatePatientOrderStatus = async ({
  connect_program_id, 
  order_id, payload
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/patient-order/${order_id}/updatestatus` ,   payload
  );
  return result;
};

export const updateTransactionBatchStatus = async (payload) => {
  const { connect_program_id, id } = payload;
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-batch/${id}/updateapprovereject` ,   payload
  );
  return result;
};

export const updateTransactionCodeStatus = async (payload) => {
  const { connect_program_id, id } = payload;
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${id}/updateapprovereject` ,   payload
  );
  return result;
};

export const postAddCycles = async ({
  program_id,
  customer_id,
  cycles,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${program_id}/dashboard/cycle`,
    { customer_id, cycles }
  );
  return result;
};

export const deleteCycle = async ({
  program_id,
  transaction_code_id,
}) => {
  const result = await apiClient.del(
    `${transactionsUrl}/${program_id}/dashboard/cycle/${transaction_code_id}`,
  );
  return result;
};

export const updateCycleDetails = async ({
  program_id,
  transaction_code_id,
  payload,
}) => {
  const result = await apiClient.patch(
    `${transactionsUrl}/${program_id}/dashboard/cycle/${transaction_code_id}`,
    payload
  );
  return result;
};

export const generateNextCycleCodeToSend = async ({
  program_id,
  payload
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${program_id}/dashboard/cycle/generate-next-code`,
    payload
  );
  return result;
};

export const markCycleAsRedeemed = async ({
  program_id,
  transaction_code_id,
  payload,
}) => {
  const result = await apiClient.post(
    `${transactionsUrl}/${program_id}/dashboard/cycle/mark-as-redeemed/${transaction_code_id}`,
    payload
  );
  return result;
};

export const markTransactionCodeAsRedeemed = async ({
  transaction_code_id,
  connect_program_id,
}) => {
  const result = await apiClient.put(
    `${transactionsUrl}/${connect_program_id}/dashboard/transaction-code/${transaction_code_id}/mark-as-redeemed`,
  );
  return result;
};